import { EpimsBaseEntityDto } from "./epim-base.dto";
export class ApplicationDto extends EpimsBaseEntityDto {
ModuleName: string;
Description: string;
NoOfUsers: number;
PaymentStatus: string;
Duration: number;
ApprovalStatus: string;
Unlimited: string;
StartDate: Date;
EndDate: Date;
AmountPaid: number;
RoleId: string;
// UserId: string;
}